import {
  Component,
  AfterViewInit,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input
} from '@angular/core'

import {v4 as uuid} from 'uuid'

import {ActivatedRoute, Router} from '@angular/router'

import {PaymentService} from '../../../payment.service'
import {PlayerIndex} from '@angular/core/src/render3/interfaces/player'
import {auth} from 'firebase'
import {AuthService} from 'src/app/auth.service'

@Component({
  selector: 'app-charge-payment',
  templateUrl: './payment-charge.component.html',
  styleUrls: ['./payment-charge.component.scss'],
  providers: [PaymentService]
})
export class PaymentChargeComponent implements AfterViewInit, OnDestroy {
  @Input() plan: any
  user: any = {}
  errorMessage = {display: false, message: ''}
  planToken = {month: 'plan_FBQzrYMeul5Eq3', year: 'plan_FBQz2d4TRIU7Z8'}
  @ViewChild('cardInfo') cardInfo: ElementRef

  card: any
  cardHandler = this.onChange.bind(this)
  error: string
  itemsPlan: any
  subitemsYear: any
  authUser: any
  trasactionInProgress = true
  suscription: any
  errorCard: boolean

  constructor(
    // private cd: ChangeDetectorRef,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    public auth: AuthService,
    private router: Router
  ) {
    this.authUser = this.auth.getUser()
    console.log('user', this.authUser)
  }

  ngAfterViewInit() {
    setTimeout(() => {
      try {
        this.errorCard = false
        this.card = elements.create('card')
        this.card.mount(this.cardInfo.nativeElement)
      } catch (e) {
        this.errorMessage.display = true
        this.errorMessage.message = 'Please check your internet connection, and reload de page!'
        this.errorCard = true
      }
    })

    //this.card.addEventListener('change', this.cardHandler)
  }

  ngOnDestroy() {
    try {
      console.log('onDestroy')
      this.card.removeEventListener('change', this.cardHandler)
      this.card.destroy()
    } catch (e) {}
  }

  onChange({error}) {
    console.log('onchange')
    if (error) {
      this.error = error.message
    } else {
      this.error = null
    }
    /* this.cd.detectChanges() */
  }

  async generateToken() {
    try {
      const card = await this.card
      const {token, error} = await stripe.createToken(card)

      if (error) {
        console.log('Something is wrong:', error)
      } else {
        console.log('Success!', token)
        this.user.userId = this.authUser.uid
        this.user.tokenId = token.id
        const customer = await this.paymentService.createCustomer(this.user)
        console.log('Customer!', customer)
        this.suscription = await this.paymentService.createSuscription(
          this.planToken[this.plan.key],
          customer['data']['id'],
          this.user.userId
        )
        this.suscription = this.suscription.data
        this.authUser.userType = 'pro'
        this.auth.updateUserPlan(this.authUser)
        console.log('suscription', this.suscription)
        this.trasactionInProgress = false
      }
    } catch (e) {
      console.log('Error', e)
      this.errorMessage.display = true
      if (
        e.message
          .toString()
          .toUpperCase()
          .indexOf('CUSTOMER') > -1 &&
        e.status === '500'
      )
        this.errorMessage.message = 'Something happend creating customer account.'
      else if (e.status === 0) this.errorMessage.message = 'Oh something was wrong.'
      else this.errorMessage.message = "Oh something was wrong. Can't complete the transaction."
    }
  }

  goToHome() {
    this.router.navigate(['/home'])
  }
}
